import { AppTypes, SuperProperties, UserPropertiesKeys } from '@griply/types';
import { getFirstOpenUserProperties, isInternalUser } from '@griply/utils';
import { version } from 'shared/constants';
import { firstOpenStorage } from 'shared/services/local-storage/first-open';
import { ID } from 'shared/types/id';
import { User } from 'shared/types/user';

import { MixpanelService } from './mixpanel-service';

const getSuperProperties = (): SuperProperties => ({
  app_type: window.electron
    ? window.electron.isMac
      ? AppTypes.ElectronMacApp
      : AppTypes.ElectronWinApp
    : AppTypes.WebApp,
  app_version: version,
});

let service: MixpanelService | undefined;
let identifiedUserId: ID | undefined;

// Identify runs on the way to every call: mixpanel-browser silently queues `people.set` until it has.
export const getMixpanelService = (user?: User | null): MixpanelService => {
  if (!service) {
    service = new MixpanelService(getSuperProperties());
  }

  if (!user?.uid || user.uid === identifiedUserId) {
    return service;
  }

  // Resetting before the first identify would unlink earlier anonymous activity; reset() also clears super properties.
  if (identifiedUserId) {
    service.reset();
    service.registerSuperProperties(getSuperProperties());
  }

  identifiedUserId = user.uid;
  service.identifyUser(user.uid);
  service.setUserProperties({
    [UserPropertiesKeys.GriplyUserId]: user.uid,
    [UserPropertiesKeys.IsInternal]: isInternalUser(user.email),
  });
  const firstOpen = getFirstOpenUserProperties(
    firstOpenStorage.read(),
    getSuperProperties().app_type,
  );
  if (firstOpen) {
    service.setUserPropertiesOnce(firstOpen);
  }

  return service;
};
